import {
    showToast
} from "./utils";
import {
    mergeNewAwardToList
} from "./helper";
import $ from 'cash-dom';
import {
    format as formatDate
} from 'date-fns';

export default class Reward {
    constructor(Options, api, eventBus, _userInfo, html, checkError) {
        this.Options = Options;
        this.Wheel = this.Options.Wheel;
        this.api = api;
        this.checkError = checkError;
        this.eventBus = eventBus;
        this.html = html;
        this._rewardData = {};
        this.__awarding = false;
        this.currentReward = {};
        this.isLoading = false;
        this.hasLogin = false;
        this.state = '';
        this.error = '';
        this.turnCount = 0;
        this.totalTurn = 0;
        this.id = 'reward-' + Date.now();
    }
    fetchRewards() {
        return this.api.fetchRewards()
            .then(data => {
                Object.assign(this._rewardData, data);
                const turn = this.getRemainTurnCount();
                if (this.Options.Wheel.is_test_mode && turn < 1) {
                    // this._rewardData.times = this._rewardData.rewards.length + 1;
                    this.turnCount = this.turnCount + 1;
                    console.log('turnCount', this.turnCount);
                }
            }).catch(this.checkError)
    }
    claimReward() {
        // console.trace('gọi claim');
        this.html.showLoading();
        return this.api.claimReward()
            .then(data => {
                this.html.hideLoading();
                Object.assign(this.currentReward, data);
                this.state = 'rolling';
            }).catch(this.checkError)
    }
    award(cb) {
        if (this.__awarding) return;
        this.__awarding = true;
        if (!this.currentReward || !this.currentReward.reward_id) {
            this.__awarding = false;
            if (this.isOutOfTurn()) {
                this.html.getModalOutOfTurn(this.Options, SETTINGS);
            } else {
                showToast('Vui lòng đợi trong giây lát - Hệ thống đang đồng bộ');
            }
            return;
        }
        this.isLoading = true;
        this.html.showLoading();
        this.eventBus.emit('reward');
        return this.api.awardReward(this.currentReward.reward_id)
            .then(resp => {
                Object.assign(this.currentReward, resp);
                if (this.isLoading) {
                    this.html.hideLoading();
                    this.isLoading = false;
                }
                if (this.Options.Wheel.game_type == 'wheel') {
                    cb(this.currentReward);
                }
                mergeNewAwardToList(this._rewardData, resp);
                this.turnCount--;
                this.updateTurnCount();
                this.__awarding = false;
                this.eventBus.emit('award-done');
            })
            .catch(this.checkError)
    }
    cancelAward(cb) {
        if (this.__awarding) return;
        this.__awarding = true;
        if (!this.currentReward || !this.currentReward.reward_id) {
            this.__awarding = false;
            if (this.isOutOfTurn()) {
                this.html.getModalOutOfTurn(this.Options, SETTINGS);
            } else {
                showToast('Vui lòng đợi trong giây lát - Hệ thống đang đồng bộ');
            }
            return;
        }
        this.isLoading = true;
        this.html.showLoading();
        this.eventBus.emit('reward');
        return this.api.cancelReward(this.currentReward.reward_id)
            .then(resp => {
                Object.assign(this.currentReward, resp);
                if (this.isLoading) {
                    this.html.hideLoading();
                    this.isLoading = false;
                }
                if (this.Options.Wheel.game_type == 'wheel') {
                    cb(this.currentReward);
                }
                mergeNewAwardToList(this._rewardData, resp);
                this.turnCount--;
                this.updateTurnCount();
                this.__awarding = false;
                this.eventBus.emit('award-done');
            })
            .catch(this.checkError)
    }
    isAwading() {
        if (this.__awarding) {
            this.error = 'IS_AWARDING';
            return false;
        }
        return true;
    }
    getRemainTurnCount() {
        var userTurnCount = this.turnCount;
        try {
            return userTurnCount;
        } catch (e) {
            return 0;
        }
    }

    getTotalTurnCount() {
        var totalTurn = this.totalTurn;
        try {
            return totalTurn;
        } catch (e) {
            return 0;
        }
    }
    addTurn(turn) {
        try {
            this.turnCount += turn;
            this.totalTurn += turn;
        } catch (e) {
            console.log('cannot add Turn', e);
        }
    }
    addTurnForMission(name, quantity) {
        var quantity = parseInt(name && quantity);
        this.addTurn(quantity);
    }

    checkRewardList() {
        const {
            rewards
        } = this._rewardData;
        let html = '';
        for (let reward of rewards) {
            const name = reward.item_name;
            const time = formatDate(new Date(reward.updated_at), 'dd-MM-yyyy HH:mm');
            const code = reward.code;
            if (reward.sku == 'BADLUCK' || reward.item_type == 'point') {
                console.log('hide code BADLUCK');
                html += `<div class="item-reward"><div class="d-flex flex-col align-items-start"><div class="reward-name"><b>${name}</b></div><div class="reward-time">${time}</div></div></div>`;
            } else {
                html += `<div class="item-reward"><div class="d-flex flex-col align-items-start"><div class="reward-name"><b>${name}</b></div><div class="reward-time">${time}</div></div><div class="reward-code">${code}</div></div>`;
            }
        }
        if (!rewards || !rewards.length) {
            html = 'Bạn chưa có phần thưởng';
        }
        $('#modal-reward-list .reward-list').html(html);
        this.html.pushModal('modal-reward-list');
    }

    getRewardData() {
        return JSON.parse(JSON.stringify(this._rewardData));

    }

    getCurrentReward() {
        return this.currentReward;
    }

    updateTurnCount() {
        this.html.renderTurn(this.getRemainTurnCount(), this.Options.Wheel.is_test_mode);
    }

    isOutOfTurn() {
        const remainTurn = this.getRemainTurnCount();
        return remainTurn <= 0;
    }

    updateTurn() {
        return this.api.updateTurn()
            .then(data => {
                if (!data) return;
                console.log('data turn count', data);
                this.turnCount = data.available;
                this.totalTurn = data.total;
                console.log('turn count', this.turnCount);
                this.html.renderTurn(this.getRemainTurnCount(), this.Options.Wheel.is_test_mode);
            })
    }

    congratulate(subject, is_popup) {
        this.eventBus.emit('award-show');
        // if (is_popup) {
        // this.html.showRewardPopup(subject, this.currentReward);
        // } else {
        this.html.showReward(this.currentReward, this.Options);
        // }
        this.currentReward = {};
    }
}